import IconButton from 'LuxKit/Button/IconButton'
import SolidTimesIcon from 'LuxKit/Icons/solid/SolidTimesIcon'
import { rem } from 'polished'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import zIndex from 'styles/tools/z-index'

const _AboveCardCloseButton = styled(IconButton)`
  position: absolute;
  bottom: calc(100% + ${rem(16)});
  right: 0;
  z-index: ${zIndex.menu};
  box-shadow: ${(props) => props.theme.shadow.flat.large};
  border-color: ${(props) => props.theme.palette.neutral.surface.normalForeground};
  background-color: ${(props) => props.theme.palette.neutral.surface.normalBackground};
`

export default function AboveCardCloseButton({ onClick }: Pick<React.ComponentProps<typeof _AboveCardCloseButton>, 'onClick'>) {
  const intl = useIntl()

  return (
    <_AboveCardCloseButton
      kind="primary"
      variant="ghost"
      size="medium"
      shape="circle"
      aria-label={intl.formatMessage({
        id: 'DdgVrGqCBVJzqHwllH-r',
        defaultMessage: 'Close',
        description: 'Aria-label for the close button above a map summary card',
      })}
      onClick={onClick}
    >
      <SolidTimesIcon />
    </_AboveCardCloseButton>
  )
}
